import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import StarBorder from '../Reusable/StarBorder';
import { videoPath } from '../../utils/imagePath';

gsap.registerPlugin(ScrollTrigger);

const SpatialEngineering = () => {
  const sectionRef = useRef(null);
  const textRef = useRef(null);
  const videoRef = useRef(null);
  const glowRef = useRef(null);

  const [isPlaying, setIsPlaying] = React.useState(true);

  const togglePlay = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.paused) {
      video.play();
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };



  return (
    <section
      ref={sectionRef}
      className=" md:min-h-screen w-full flex flex-col gap-16 justify-center px-4 md:px-10 py-20"
    >
      {/* ================= TEXT ================= */}
      <div ref={textRef} className="max-w-5xl text-center mx-auto space-y-4">
        <StarBorder color="red" thickness={1.5} speed="4s">
          <span className="text-line block">Business Ready Features</span>
        </StarBorder>

        <h1 className="text-3xl md:text-5xl  text-white z-50">
          <span className="text-line block font-telegraf ">
            Spatial Engineering has never been easier. 
          </span>
        </h1>

        <p className="text-[#bbbbbb] max-w-4xl mx-auto">
          <span className="text-line block text-xs md:text-base">
            Our Visual Editor offers scalable infrastructure for millions of
            users, industry-ready templates for quick deployment,
            enterprise-grade security, seamless cross-platform integration,
            precision mapping for real-world accuracy, and fully customizable
            solutions for diverse business needs.
          </span>
        </p>
      </div>

      {/* ================= VIDEO ================= */}
      <div className="relative flex justify-center px-2 md:px-14 group">
        {/* Red glow */}
        <div
          ref={glowRef}
          className="absolute -top-10 w-full md:w-[80%] h-[220px] rounded-full blur-[120px] opacity-90 transition-opacity duration-300 group-hover:opacity-100"
          style={{
            background:
              'radial-gradient(circle, rgba(255,0,0,0.8) 0%, rgba(255,0,0,0.35) 35%, transparent 70%)',
          }}
        />

        {/* VIDEO */}
        <video
          ref={videoRef}
          muted
          playsInline
          autoPlay
          loop={false}
          className="relative z-10 max-w-full w-full md:w-[80%] rounded-2xl border-2 border-red-700"
        >
          <source src={videoPath?.DemoPlay} type="video/mp4" />
        </video>

        {/* PLAY / PAUSE OVERLAY */}
        <button
          onClick={togglePlay}
          className="
      absolute left-[5%] md:left-[15%] bottom-4 md:bottom-10 z-20 flex items-center justify-center
      opacity-0 scale-95
      group-hover:opacity-100 group-hover:scale-100
      transition-all duration-300 ease-out
      focus:opacity-100 focus:scale-100
    "
          aria-label={isPlaying ? 'Pause video' : 'Play video'}
        >
          <div className=" w-10 h-10  md:w-16 md:h-16 rounded-full bg-black/60 backdrop-blur-md border border-white/20  items-center justify-center hidden group-hover:flex">
            {isPlaying ? (
              /* PAUSE ICON */
              <div className="flex gap-1 md:gap-2">
                <span className=" w-1 md:w-2 h-4 md:h-8 bg-white rounded-sm" />
                <span className=" w-1 md:w-2 h-4  md:h-8 bg-white rounded-sm" />
              </div>
            ) : (
              /* PLAY ICON */
              <div
                className="ml-1 w-0 h-0
          border-l-[16px] border-l-white
          border-y-[10px] border-y-transparent"
              />
            )}
          </div>
        </button>
      </div>
    </section>
  );
};

export default SpatialEngineering;
